import React, {useState} from 'react';
import {Chip, TextField, makeStyles} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {BRAND} from '../../settings/dashboardStyles';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    chip: {
        background: BRAND.creamSoft,
        border: `1px solid ${BRAND.goldSoft}`,
        color: BRAND.deep,
        fontWeight: 500,
        '& .MuiChip-deleteIcon': {
            color: BRAND.inkSoft,
            '&:hover': {color: BRAND.deep},
        },
    },
    inputRoot: {
        gap: theme.spacing(0.5),
    },
}));

export default function ChipInput({
    label,
    placeholder,
    value = [],
    onChange,
    options = [],
    error = null,
    name,
    helperText,
    fullWidth = true,
}) {
    const classes = useStyles();
    const [inputValue, setInputValue] = useState('');

    const emit = (next) => {
        const cleaned = Array.from(new Set(
            next.map((v) => (typeof v === 'string' ? v.trim() : String(v).trim())).filter(Boolean)
        ));
        onChange(cleaned);
    };

    const handleChange = (_event, newValue) => {
        emit(newValue);
    };

    const handleInputChange = (_event, newInput, reason) => {
        if (reason === 'reset') {
            setInputValue('');
            return;
        }
        if (newInput.includes(',')) {
            const parts = newInput.split(',');
            const tail = parts.pop();
            const additions = parts.map((p) => p.trim()).filter(Boolean);
            if (additions.length) {
                emit([...value, ...additions]);
            }
            setInputValue(tail.trimStart());
            return;
        }
        setInputValue(newInput);
    };

    const handleBlur = () => {
        const trimmed = inputValue.trim();
        if (trimmed) {
            emit([...value, trimmed]);
            setInputValue('');
        }
    };

    return (
        <Autocomplete
            multiple
            freeSolo
            fullWidth={fullWidth}
            className={classes.root}
            options={options}
            value={value}
            inputValue={inputValue}
            onChange={handleChange}
            onInputChange={handleInputChange}
            onBlur={handleBlur}
            classes={{inputRoot: classes.inputRoot}}
            renderTags={(items, getTagProps) =>
                items.map((option, index) => (
                    <Chip
                        size="small"
                        variant="outlined"
                        label={option}
                        className={classes.chip}
                        {...getTagProps({index})}
                    />
                ))
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    name={name}
                    label={label}
                    placeholder={value.length === 0 ? placeholder : ''}
                    variant="outlined"
                    error={Boolean(error)}
                    helperText={error || helperText}
                />
            )}
        />
    );
}
